import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import AddItemModal from './modal/AddItemModal'
import ManageItemModal from './modal/ManageItemModal'
import { GlobalContext } from '../context/GlobalState'

const List = () => {
  const context = useContext(GlobalContext)
  const { items, lists, members, getMembers } = context
  const { listID } = useParams()
  const [ thisList, setThisList ] = useState(null)
  const filteredItems = items.filter(item => item.listID === listID)
  const [ showModal, setShowModal ] = useState(false)
  const [ showManageModal, setShowManageModal ] = useState(false)
  const [ itemToManage, setItemToManage ] = useState(null)

  /* get all members who share this list and set current list into local state */
  useEffect (() => {
      getMembers(listID)
      setThisList(lists.filter(list => list.listID === listID)[0])
  //eslint-disable-next-line
  }, [])

  // open edit item modal
  const manageItem = theitem => {
    setItemToManage(theitem)
    setShowManageModal(true)
  }

  // calculate progress bar
  const progressPCT = () => {
    return (filteredItems.reduce((total, item) => total + parseFloat(item.cost), 0 ).toFixed(2)/thisList.budgetAmt)*100
  }

  if (thisList === null) 
    return "loading..."
  else
  return (
    <div className="all-pages-bg">
      <Header style={'blurb'} />
      <div className="list-content">
        <div className="list-info">
          <h5>{thisList.listName}</h5>          
          <p>Created: {thisList.createDate}</p>
          <p className="share-list-pill-holder">Shared with: </p>
          {members.map(mem => <span key={mem.userID} className='share-span'>{mem.username}</span>)}
        </div>

        {thisList.hasBudget === 'Y' && (
          <div className="budget">Budget <span style={{float:"right"}}>${thisList.budgetAmt}</span>
            <div className="budget-bar">
              <div style={{width: progressPCT() + '%', backgroundColor: progressPCT() > 100 && 'red'}}>
              { progressPCT() > 24 && 
                <span className="total_span_gt25">
                  ${filteredItems.reduce((total, item) => total + parseFloat(item.cost), 0 ).toFixed(2)}
                </span>
              }
              </div>
              { progressPCT() < 25 && 
                <span className="total_span_lt25">
                  ${filteredItems.reduce((total, item) => total + parseFloat(item.cost), 0 ).toFixed(2)}
                </span>
              }
            </div>
          </div>
        )}
        
        <ul className="list-holder" role="list">
          {filteredItems.map((item, index) => (
            <li className="list-item" key={index} onClick= {() => manageItem(item)}>
              <p>{item.itemText} 
                {lists.filter(list => list.listID === listID)[0].hasBudget === 'Y' ? 
                  <span className="cost-span">${item.cost}</span> :
                  <span className="qty-span">(qty: {item.qty})</span> }
              </p>
              <p className="list-note">{item.note}</p>
            </li>
          ))}
        </ul>
        <button className="standard_bttn" onClick={() => setShowModal(true) }>Add New Item</button>
      </div>
      <Footer />
      <AddItemModal showModal={showModal} setShowModal={setShowModal} listID={listID} />
      <ManageItemModal showManageModal={showManageModal} setShowManageModal={setShowManageModal} itemToManage={itemToManage} setItemToManage={setItemToManage} />
    </div>
  )
}

export default List